export default "__VITE_ASSET__BhBK11XA__"